// removed by extract-text-webpack-plugin
module.exports = {"withPointer":"_1L82yJ34IJDDE0cOh2yVbQ","modal":"_3P_m6Xusu5jC9QrKnOaEv7","title":"_38_mfpAv4wOWzTAjZwmnqU","contentWrapper":"_1XGUgQDtGFy3VDKSjKMsyf","content":"_2UsMIm12GdXGp1LHkZDxF-","buttons":"_-cVKPuDErzTxM6ogo03s3","next":"DaAajU-Zx1DX49slsp1Vc","enabled":"_2hVR104ShtZoJzAlQzhmGV","gray":"_3SUbMBIoz1WQeGc-81sDps","cancel":"_3YwHHk8JfUg1ytOR7dNjW8"};


//////////////////
// WEBPACK FOOTER
// ./components/generalComponents/infoModal.scss
// module id = 1610
// module chunks = 0